import { render, staticRenderFns } from "./ClassRoom.vue?vue&type=template&id=151f0c49&v-bind=%24props"
import script from "./ClassRoom.vue?vue&type=script&lang=js"
export * from "./ClassRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports